/** Utilitários de CPF/CNPJ (Brasil) — espelho do backend. */

export function onlyDigits(value: string): string {
  return String(value ?? "").replace(/\D/g, "");
}

export function formatCpfCnpjInput(raw: string): string {
  const d = onlyDigits(raw).slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{0,2})$/, "$1-$2");
  }
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{0,2})$/, "$1-$2");
}

function allSameDigits(d: string): boolean {
  return /^(\d)\1+$/.test(d);
}

export function validateCpf(cpf: string): boolean {
  const d = onlyDigits(cpf);
  if (d.length !== 11 || allSameDigits(d)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += Number(d[i]) * (10 - i);
  let mod = (sum * 10) % 11;
  if (mod === 10) mod = 0;
  if (mod !== Number(d[9])) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += Number(d[i]) * (11 - i);
  mod = (sum * 10) % 11;
  if (mod === 10) mod = 0;
  return mod === Number(d[10]);
}

export function validateCnpj(cnpj: string): boolean {
  const d = onlyDigits(cnpj);
  if (d.length !== 14 || allSameDigits(d)) return false;

  const calc = (length: number) => {
    const weights =
      length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < weights.length; i++) sum += Number(d[i]) * weights[i];
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  return calc(12) === Number(d[12]) && calc(13) === Number(d[13]);
}

export function validateBrDocument(raw: string): { valid: boolean; error?: string } {
  const digits = onlyDigits(raw);
  if (digits.length === 0) return { valid: false, error: "Informe o CPF ou CNPJ." };
  if (digits.length === 11) {
    return validateCpf(digits) ? { valid: true } : { valid: false, error: "CPF inválido." };
  }
  if (digits.length === 14) {
    return validateCnpj(digits) ? { valid: true } : { valid: false, error: "CNPJ inválido." };
  }
  return { valid: false, error: "Informe um CPF (11 dígitos) ou CNPJ (14 dígitos)." };
}
